export const sendRegisterTrackToGoogleAdsAndAnalytics = () => {
  // Google tag manager
  // @ts-expect-error
  if (window.gtag) {
    // @ts-expect-error
    window.gtag('event', 'conversion', {
      send_to: 'AW-769894422/7wKWCJ_UkNwBEJbQju8C',
    });
    // @ts-expect-error
    window.gtag('event', 'Registro', {
      event_category: 'Registro',
      event_label: 'Registro Usuario',
      send_to: 'UA-60829200-1',
    });
  }
};

export default sendRegisterTrackToGoogleAdsAndAnalytics;
